import {
    teal200,
    teal400,
    teal700,
    grey100,
    grey900,
} from "material-ui/styles/colors";

var TealTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      teal700,
        primary2color:      teal400,
        primary3color:      teal200,
        accent1color:       "#E73677",
        accent2color:       "#D0FFCA",
        accent3color:       "#FF9797",
        textColor:          grey900,
        canvasColor:        grey100,
        alternateTextColor: teal200, // Button background color.
    }
};

export default TealTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/TealTheme.js
 **/